function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "collapsed", "collapsedHeight", "onCollapsibleChanged", "onToggleCollapsed", "overflowThreshold", "shadow"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { LinkButton } from '@hypothesis/frontend-shared';
import classnames from 'classnames';
import { useCallback, useLayoutEffect, useRef, useState } from 'preact/hooks';
import { observeElementSize } from '../utils/observe-element-size';
import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/**
 * An optional toggle link at the bottom of an excerpt which controls whether
 * it is expanded or collapsed.
 */
function InlineControl(_ref) {
  var isCollapsed = _ref.isCollapsed,
    setCollapsed = _ref.setCollapsed,
    _ref$inlineControlExp = _ref.inlineControlExpandText,
    inlineControlExpandText = _ref$inlineControlExp === void 0 ? 'More' : _ref$inlineControlExp,
    _ref$inlineControlCol = _ref.inlineControlCollapseText,
    inlineControlCollapseText = _ref$inlineControlCol === void 0 ? 'Less' : _ref$inlineControlCol,
    inlineControlStyle = _ref.inlineControlStyle,
    inlineControlClasses = _ref.inlineControlClasses;
  return _jsx("div", {
    className: classnames(
    // Position these controls at the bottom right of the excerpt
    'absolute block right-0 bottom-0',
    // Give extra width for larger tap target and gradient fade
    // Fade transparent-to-white left-to-right to make the toggle
    // control text (More/Less) more readable above other text.
    // This gradient is implemented to-left to take advantage of Tailwind's
    // automatic to-transparent calculation: this avoids Safari's problem
    // with transparents in gradients:
    // https://bugs.webkit.org/show_bug.cgi?id=150940
    // https://tailwindcss.com/docs/gradient-color-stops#fading-to-transparent
    'w-20 bg-gradient-to-l from-white'),
    children: _jsx("div", {
      className: "flex justify-end",
      children: _jsx(LinkButton, {
        variant: "text",
        onClick: function onClick() {
          return setCollapsed(!isCollapsed);
        },
        expanded: !isCollapsed,
        title: "Toggle visibility of full excerpt text",
        style: inlineControlStyle,
        classes: inlineControlClasses,
        underline: "always",
        inline: true,
        children: isCollapsed ? inlineControlExpandText : inlineControlCollapseText
      })
    })
  });
}
/**
 * A container which truncates its content when they exceed a specified height.
 *
 * The collapsed state of the container can be handled either via internal
 * controls (if `inlineControls` is `true`) or by the caller using a custom
 * control.
 */
export default function Excerpt(_ref2) {
  var children = _ref2.children,
    collapsed = _ref2.collapsed,
    collapsedHeight = _ref2.collapsedHeight,
    onCollapsibleChanged = _ref2.onCollapsibleChanged,
    onToggleCollapsed = _ref2.onToggleCollapsed,
    _ref2$overflowThresho = _ref2.overflowThreshold,
    overflowThreshold = _ref2$overflowThresho === void 0 ? 0 : _ref2$overflowThresho,
    shadow = _ref2.shadow,
    rest = _objectWithoutProperties(_ref2, _excluded);
  // If `collapsed` is present, treat this as a controlled component
  var isControlled = typeof collapsed === 'boolean';
  // Only use this local state if Excerpt is uncontrolled
  var _useState = useState(collapsed !== null && collapsed !== void 0 ? collapsed : true),
    _useState2 = _slicedToArray(_useState, 2),
    uncontrolledCollapsed = _useState2[0],
    setUncontrolledCollapsed = _useState2[1];
  var isCollapsed = isControlled ? collapsed : uncontrolledCollapsed;
  var setCollapsed = useCallback(function (collapsed) {
    onToggleCollapsed === null || onToggleCollapsed === void 0 || onToggleCollapsed(collapsed);
    if (!isControlled) {
      setUncontrolledCollapsed(collapsed);
    }
  }, [isControlled, onToggleCollapsed]);
  var inlineControl = rest.inlineControl;
  var withShadow = shadow !== null && shadow !== void 0 ? shadow : !inlineControl;
  var contentElement = useRef(null);

  // Measured height of `contentElement` in pixels
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    contentHeight = _useState4[0],
    setContentHeight = _useState4[1];

  // Update the measured height of the content container after initial render,
  // and when the size of the content element changes.
  var updateContentHeight = useCallback(function () {
    var newContentHeight = contentElement.current.clientHeight;
    setContentHeight(newContentHeight);

    // prettier-ignore
    var isCollapsible = newContentHeight > collapsedHeight + overflowThreshold;
    onCollapsibleChanged === null || onCollapsibleChanged === void 0 || onCollapsibleChanged(isCollapsible);
  }, [collapsedHeight, onCollapsibleChanged, overflowThreshold]);
  useLayoutEffect(function () {
    var cleanup = observeElementSize(contentElement.current, updateContentHeight);
    updateContentHeight();
    return cleanup;
  }, [updateContentHeight]);

  // Render the (possibly truncated) content and controls for
  // expanding/collapsing the content.
  // prettier-ignore
  var isOverflowing = contentHeight > collapsedHeight + overflowThreshold;
  var isExpandable = isOverflowing && isCollapsed;
  var contentStyle = {};
  if (contentHeight !== 0) {
    contentStyle.maxHeight = isExpandable ? collapsedHeight : contentHeight;
  }
  return _jsxs("div", {
    "data-testid": "excerpt-container",
    className: classnames('relative overflow-hidden', 'transition-[max-height] ease-in duration-150'),
    style: contentStyle,
    children: [_jsx("div", {
      className: classnames(
      // Establish new block-formatting context to prevent margin-collapsing
      // in descendent elements from potentially "leaking out" and pushing
      // this element down from the top of the container.
      // See https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Block_formatting_context
      // See https://github.com/hypothesis/client/issues/1518
      'inline-block w-full'),
      "data-testid": "excerpt-content",
      ref: contentElement,
      children: children
    }), _jsx("div", {
      "data-testid": "excerpt-expand",
      role: "presentation",
      onClick: function onClick() {
        return setCollapsed(false);
      },
      className: classnames(
      // This element provides a clickable area at the bottom of an
      // expandable excerpt to expand it.
      'transition-[opacity] duration-150 ease-linear', 'absolute w-full bottom-0 h-touch-minimum', {
        // For expandable excerpts with shadow, style this element with a
        // shadow-like gradient
        'bg-gradient-to-b from-white/0 via-95% via-black/10 to-100% to-black/15': withShadow && isExpandable,
        'bg-none': !withShadow,
        // Don't make the shadow visible OR clickable if there's nothing
        // to do here (the excerpt isn't expandable)
        'opacity-0 pointer-events-none': !isExpandable
      }),
      title: "Show the full excerpt"
    }), isOverflowing && inlineControl && _jsx(InlineControl, _objectSpread({
      isCollapsed: isCollapsed,
      setCollapsed: setCollapsed
    }, rest))]
  });
}
//# sourceMappingURL=Excerpt.js.map